module.exports = {
	"de": {
		"titel": "Jetzt kaufen",
		"online_shop": "Online Shop"
	},
	"en": {
		"titel": "Buy",
		"online_shop": "Online Shop"
	}
};


//////////////////
// WEBPACK FOOTER
// ./lib/runes-set-order/locales.json
// module id = 21
// module chunks = 0